import {
	TEACHER_PAGES_SCHEDULE_VIEW,
	COURSE,
	COURSE_GROUP,
	USERS_LIST,
	DATATABLE_EXPORT,
} from "../../../../../Config/ApiUrl";

export const AttendanceClassGroupSchema = {
	components: {},

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			tableId: "schedule-table",
			rowData: {},
			formId: "schedule-form",
			tableColumns: [
				{
					title: "Week",
					type: "text",
					key: "week_attendance",
				},
				{
					title: "Day",
					type: "text",
					key: "day_name",
				},
				{
					title: "Time",
					type: "text",
					key: "time",
				},
				{
					title: "Note",
					type: "text",
					key: "teaching_type_code",
				},
				{
					title: "Teach",
					type: "text",
					key: "teach_full_name",
				},
				{
					title: "Teacher Side",
					type: "text",
					key: "teach_side_full_name",
				},
				{
					title: "Teacher Trainer",
					type: "text",
					key: "teach_trainer_full_name",
				},
			],
			ENDPOINT:
				TEACHER_PAGES_SCHEDULE_VIEW + "?date=" + this.getCurrentDate(),
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "Schedule",
				url:
					TEACHER_PAGES_SCHEDULE_VIEW +
					"?date=" +
					this.getCurrentDate(),
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: false,
				columns: [],
				actions: [
					// {
					// 	title: this.$t("view"),
					// 	icon: "eye",
					// 	type: "viewAndHideTeacherPagesStudentAttendance",
					// },
				],
				filters: [
					{
						title: "Course",
						type: "search-and-select-filter",
						key: "course_id",
						settings: {
							url: `/${COURSE}`, // this url will hit every search action
							modifire: (v) => {
								return { id: v.id, course_name: v.course_name };
							},
							per_page: 10, // default 10, you can change it any number. min 10 encourage to use
							queryName: "search", // default 'search', this key will use for query build link '../endpoind?last_name=shi&moreparam...'
							loader: "app-pre-loader", // default app-overlay-loder
							multiple: true, // default false, if you need to select multiple item so make it true
							params: {
								is_active: true,
							}, // params object will be appended with your url after search param like '../endpoint?last_name=shishir&type=type1&isWanted=true'
						},
						listValueField: "course_name",
					},
					{
						title: "Course Group",
						type: "search-and-select-filter",
						key: "course_group_id",
						settings: {
							url: `/${COURSE_GROUP}`, // this url will hit every search action
							modifire: (v) => {
								return {
									id: v.id,
									course_group_name: v.course_group_name,
								};
							},
							per_page: 10, // default 10, you can change it any number. min 10 encourage to use
							queryName: "search", // default 'search', this key will use for query build link '../endpoind?last_name=shi&moreparam...'
							loader: "app-pre-loader", // default app-overlay-loder
							multiple: true, // default false, if you need to select multiple item so make it true
							params: {
								is_active: true,
							}, // params object will be appended with your url after search param like '../endpoint?last_name=shishir&type=type1&isWanted=true'
						},
						listValueField: "course_group_name",
					},
					{
						title: "Teacher",
						type: "search-and-select-filter",
						key: "teach_id",
						settings: {
							url: `/${USERS_LIST}`, // this url will hit every search action
							modifire: (v) => {
								return {
									id: v.id,
									full_name: v.full_name,
								};
							},
							per_page: 10, // default 10, you can change it any number. min 10 encourage to use
							queryName: "search", // default 'search', this key will use for query build link '../endpoind?last_name=shi&moreparam...'
							loader: "app-pre-loader", // default app-overlay-loder
							multiple: true, // default false, if you need to select multiple item so make it true
							params: {
								is_active: true,
							}, // params object will be appended with your url after search param like '../endpoint?last_name=shishir&type=type1&isWanted=true'
						},
						listValueField: "full_name",
					},
				],
				showFilter: true,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 5,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {
		/**
		 * Delete confirmed $emit Form confirmation modal
		 */
		onDelete() {
			let url = `${this.ENDPOINT}/${this.rowData.id}`;
			this.deleteLoader = true;
			this.axiosDelete(url)
				.then((response) => {
					this.deleteLoader = false;
					$("#demo-delete").modal("hide");
					this.onCancelDelete();
					this.$toastr.s(response.data.message);
					// this.searchAndSelectFilterOptions();
				})
				.catch(({ err }) => {})
				.finally(() => this.$hub.$emit(`reload-${this.tableId}`));
		},
		onCancelDelete() {
			this.deleteConfirmationModalActive = false;
			this.reSetData();
		},
		reSetData() {
			this.rowData = {};
			this.selectedUrl = "";
		},
		getCurrentDate() {
			const today = new Date();
			const year = today.getFullYear();
			const month = (today.getMonth() + 1).toString().padStart(2, "0"); // Adding 1 as months are zero-indexed
			const day = today.getDate().toString().padStart(2, "0");

			return `${year}-${month}-${day}`;
		},
	},
};
